import React, { useState, useEffect } from 'react';
import { Link as RouterLink, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import validate from 'validate.js';
import { makeStyles } from '@material-ui/styles';
import majors from '../NewOffer/components/Form/majors';
import FacebookIcon from '@material-ui/icons/Facebook';
import GithubIcon from '@material-ui/icons/GitHub';
import LinkedinIcon from '@material-ui/icons/LinkedIn';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';

import {
  Grid,
  Button,
  IconButton,
  TextField,
  Link,
  Checkbox,
  Typography,
  Breadcrumbs,
} from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import {
  SignUpAPIReq
} from '../../utils/requests'

import FormControlLabel from '@material-ui/core/FormControlLabel';
const schools = [
  {
    value: 'SBA',
    label: 'School of business and administration'
  },
  {
    value: 'SHSS',
    label: 'School of Humanities and Social Sciences'
  },
  {
    value: 'SSE',
    label: 'School of Science and Engineering'
  }
];

const schema = {
  firstName: {
    presence: { allowEmpty: false, message: 'is required' },
    length: {
      maximum: 40
    }
  },
  lastName: {
    presence: { allowEmpty: false, message: 'is required' },
    length: {
      maximum: 40
    }
  },
  password: {
    presence: { allowEmpty: false, message: 'is required' },
    length: {
      minimum: 6,
      message: 'must be at least 6 characters',
      maximum: 18
    }
  },
  aui_id: {
    presence: { allowEmpty: false, message: 'is required' },
    length: {
      maximum: 5
    }

  },
  email: {
    presence: { allowEmpty: false, message: 'is required' },
    length: {
      maximum: 100
    }
  },
  phoneNumber: {
    presence: { allowEmpty: false, message: 'is required' },
    length: {
      maximum: 12
    }
  },
  major: {
    presence: { allowEmpty: false, message: 'is required' },
    length: {
      maximum: 100
    }
  },
  minor: {
    presence: { allowEmpty: false, message: 'is required' },
    length: {
      maximum: 100
    }
  },
  currentJob:{
    presence: { allowEmpty: true, message: 'is required' },
    length: {
      maximum: 100
    }
  },
  LinkedIn_username:{
    presence: { allowEmpty: true, message: 'is required' },
    length: {
      maximum: 100
    }
  },
  Github_username:{
    presence: { allowEmpty: true, message: 'is required' },
    length: {
      maximum: 100
    },
  }
};

function Alert(props) {
  return <MuiAlert
    elevation={6}
    variant="filled"
    {...props}
         />;
}

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: 'white',
    height: '100%'
  },
  grid: {
    height: '100%'
  },
  quoteContainer: {
    [theme.breakpoints.down('md')]: {
      display: 'none'
    }
  },
  quote: {
    backgroundColor: 'white',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundImage: 'url(/images/auth.jpg)',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    boxShadow:'inset 0 0 0 2000px rgba(26, 86, 50, 0.6)'
  },
  quoteInner: {
    textAlign: 'center',
    flexBasis: '600px'
  },
  quoteText: {
    color: theme.palette.white,
    fontWeight: 300
  },
  name: {
    marginTop: theme.spacing(3),
    color: theme.palette.white
  },
  bio: {
    color: theme.palette.white
  },
  contentContainer: {},
  content: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  contentHeader: {
    display: 'flex',
    alignItems: 'center',
    paddingTop: theme.spacing(5),
    paddingBototm: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2)
  },
  logoImage: {
    marginLeft: theme.spacing(4)
  },
  contentBody: {
    flexGrow: 1,
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      justifyContent: 'center'
    }
  },
  form: {
    paddingLeft: 100,
    paddingRight: 100,
    paddingBottom: 125,
    flexBasis: 700,
    [theme.breakpoints.down('sm')]: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    }
  },
  back: {
    paddingTop: theme.spacing(3)
  },
  title: {
    marginTop: theme.spacing(3)
  },
  textField: {
    marginTop: theme.spacing(2)
  },
  policy: {
    marginTop: theme.spacing(1),
    display: 'flex',
    alignItems: 'center'
  },
  policyCheckbox: {
    marginLeft: '-14px'
  },
  signUpButton: {
    margin: theme.spacing(2, 0)
  }
}));

const SignUp = props => {
  const { history } = props;

  const classes = useStyles();

  const [formState, setFormState] = useState({
    isValid: false,
    values: {
      firstName: '',
      lastName: '',
      phoneNumber: '',
      email: '',
      password: '',
      aui_id: '',
      school: 'SBA',
      major: 'BBA',
      minor: '',
      isAlumni: false,
      currentJob: '',
      LinkedIn_username: '',
      Github_username: '',
    },
    touched: {},
    errors: {}
  });

  const [open, setOpen] = React.useState(false);
  const [message, setMessage] = React.useState('false');

  const handleError = (message) => {
    setMessage(message);
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };


  useEffect(() => {
    const errors = validate(formState.values, schema);

    setFormState(formState => ({
      ...formState,
      isValid: errors ? false : true,
      errors: errors || {}
    }));
  }, [formState.values]);

  const handleChange = event => {
    event.persist();

    if(event.target.value.match(/^[a-zA-Z0-9\s._èéêàá?!\[\]();,-@]*$/)){

      setFormState(formState => ({
        ...formState,
        values: {
          ...formState.values,
          [event.target.name]:
            event.target.type === 'checkbox'
              ? event.target.checked
              : event.target.value
        },
        touched: {
          ...formState.touched,
          [event.target.name]: true
        }
      }));
    }

  };


  function handleSignUpClick(e) {
    e.preventDefault();
    return SignUpAPIReq(formState.values.aui_id, formState.values.firstName, formState.values.lastName, formState.values.email, formState.values.phoneNumber, 3, formState.values.school, formState.values.major, formState.values.minor, formState.values.currentJob, formState.values.LinkedIn_username, formState.values.Github_username, true, formState.values.password )
      .then(res=>{
        if (res.status === 'fail')
          handleError(res.error.message + ' (' + res.error.code + ')')
        else if (res)
          history.push('/Activation');
      })

  }

  const handleBack = () => {
    history.goBack();
  };


  const hasError = field =>
    formState.touched[field] && formState.errors[field] ? true : false;

  return (
    <div>
      <Grid
        container
      >
        <Grid
          className={classes.quoteContainer}
          item
          lg={5}
        >
          <div className={classes.quote}>
            <div className={classes.quoteInner}>
              <Typography
                className={classes.quoteText}
                variant="h1"
              >
                Once an AUIer, always an AUIer
              </Typography>
              <div className={classes.person}>
                <Typography
                  className={classes.name}
                  variant="body1"
                >
                  Welcome to our platform
                </Typography>
                <Typography
                  className={classes.bio}
                  variant="body2"
                >
                  Students & Alumni, united!
                </Typography>
              </div>
            </div>
          </div>
        </Grid>
        <Grid
          className={classes.content}
          item
          lg={7}
          xs={12}
        >
          <div className={classes.content} >
            <div className={classes.contentBody}>
              <form
                className={classes.form}
                onSubmit={handleSignUpClick}
              >
                <div className={classes.back}>
                  <Button
                    color="primary"
                    onClick={handleBack}
                    startIcon={<ArrowBackIcon />}
                    variant="outlined"
                  >
                    Return to login page
                  </Button>
                  &nbsp;
                  <Button
                    color="primary"
                    href="mailto:contact@auicareerspark.com"
                    variant="outlined"
                  >
                    I am an employer (non-AUI)
                  </Button>
                  
                </div>
                <div>
                  <br />
                  <Alert severity="warning">Please note that unless you login using Office365, your account will be pending verification.</Alert>
                </div>
                <Typography
                  className={classes.title}
                  variant="h3"
                >
                  Account Information
                </Typography>
                <TextField
                  className={classes.textField}
                  error={hasError('firstName')}
                  fullWidth
                  helperText={
                    hasError('firstName') ? formState.errors.firstName[0] : null
                  }
                  label="First name*"
                  name="firstName"
                  onChange={handleChange}
                  type="text"
                  value={formState.values.firstName || ''}
                  variant="outlined"
                />
                <TextField
                  className={classes.textField}
                  error={hasError('lastName')}
                  fullWidth
                  helperText={
                    hasError('lastName') ? formState.errors.lastName[0] : null
                  }
                  label="Last name*"
                  name="lastName"
                  onChange={handleChange}
                  type="text"
                  value={formState.values.lastName || ''}
                  variant="outlined"
                />

                <TextField
                  className={classes.textField}
                  error={hasError('email')}
                  fullWidth
                  helperText={
                    hasError('email') ? formState.errors.email[0] : null
                  }
                  label="Email*"
                  name="email"
                  onChange={handleChange}
                  type="text"
                  value={formState.values.email || ''}
                  variant="outlined"
                />

                <TextField
                  className={classes.textField}
                  error={hasError('phoneNumber')}
                  fullWidth
                  helperText={
                    hasError('phoneNumber') ? formState.errors.phoneNumber[0] : null
                  }
                  label="Phone Number*"
                  name="phoneNumber"
                  onChange={handleChange}
                  type="number"
                  value={formState.values.phoneNumber || ''}
                  variant="outlined"
                />
                <TextField
                  className={classes.textField}
                  error={hasError('password')}
                  fullWidth
                  helperText={
                    hasError('password') ? formState.errors.password[0] : null
                  }
                  label="Password*"
                  name="password"
                  onChange={handleChange}
                  type="password"
                  value={formState.values.password || ''}
                  variant="outlined"
                />

                <Typography
                  className={classes.title}
                  variant="h3"
                >
                  Academic Information
                </Typography>
                <TextField
                  className={classes.textField}
                  error={hasError('aui_id')}
                  fullWidth
                  helperText={
                    hasError('aui_id') ? formState.errors.aui_id[0] : null
                  }
                  label="AUI ID*"
                  name="aui_id"
                  onChange={handleChange}
                  type="number"
                  value={formState.values.aui_id || ''}
                  variant="outlined"
                />
                <TextField
                  style={{}}
                  fullWidth
                  label="School*"
                  name="school"
                  onChange={handleChange}
                  required
                  select
                  // eslint-disable-next-line react/jsx-sort-props
                  SelectProps={{native: true}}
                  value={formState.values.school}
                  variant="outlined"
                >
                  {schools.map(option => (
                    <option
                      key={option.value}
                      value={option.value}
                    >
                      {option.label}
                    </option>
                  ))}
                </TextField>
                <TextField
                  className={classes.textField}
                  fullWidth
                  label="Major*"
                  name="major"
                  onChange={handleChange}
                  required
                  select
                  // eslint-disable-next-line react/jsx-sort-props
                  SelectProps={{native: true}}
                  value={formState.values.major}
                  variant="outlined"
                >
                  {majors.map(option => (
                    <option
                      key={option.code}
                      value={option.code}
                    >
                      {option.major_name}
                    </option>
                  ))}

                </TextField>
                <TextField
                  className={classes.textField}
                  error={hasError('minor')}
                  fullWidth
                  helperText={
                    hasError('minor') ? formState.errors.minor[0] : null
                  }
                  label="Minor*"
                  name="minor"
                  onChange={handleChange}
                  type="text"
                  value={formState.values.minor || ''}
                  variant="outlined"
                />
                <TextField
                  className={classes.textField}
                  error={hasError('currentJob')}
                  fullWidth
                  helperText={
                    hasError('currentJob') ? formState.errors.currentJob[0] : null
                  }
                  label="Current Job"
                  name="currentJob"
                  onChange={handleChange}
                  type="text"
                  value={formState.values.currentJob || ''}
                  variant="outlined"
                />


                {/* <div className={classes.isAlumni} >
                  <Checkbox
                    checked={formState.values.isAlumni || false}
                    className={classes.policyCheckbox}
                    color="white"
                    name="isAlumni"
                    onChange={handleChange}
                  />
                  <Typography
                    className={classes.policyText}
                    color="white"
                    variant="body1"
                  >
                    I am an alumni
                  </Typography>

                </div> */}

                <Typography
                  className={classes.title}
                  variant="h3"
                >
                  Social Medial Information
                </Typography>

                <TextField
                  className={classes.textField}
                  error={hasError('LinkedIn_username')}
                  fullWidth
                  helperText={
                    hasError('LinkedIn_username') ? formState.errors.LinkedIn_username[0] : null
                  }
                  label="LinkedIn username"
                  name="LinkedIn_username"
                  onChange={handleChange}
                  type="site"
                  value={formState.values.LinkedIn_username || ''}
                  variant="outlined"
                />
                
                <TextField
                  className={classes.textField}
                  error={hasError('Github_username')}
                  fullWidth
                  helperText={
                    hasError('Github_username') ? formState.errors.Github_username[0] : null
                  }
                  label="Github Username"
                  name="Github_username"
                  onChange={handleChange}
                  type="website"
                  value={formState.values.Github_username || ''}
                  variant="outlined"
                />
                <Button
                  className={classes.signUpButton}
                  color="primary"
                  disabled={!formState.isValid}
                  fullWidth
                  onClick={handleSignUpClick}
                  size="large"
                  type="submit"
                  variant="contained"
                >
                  Sign up now
                </Button>
              </form>
            </div>
          </div>
        </Grid>
      </Grid>
      <Snackbar
        autoHideDuration={6000}
        onClose={handleClose}
        open={open}
      >
        <Alert
          onClose={handleClose}
          severity="error"
        >
          {message}
        </Alert>
      </Snackbar>

    </div>
  );
};

SignUp.propTypes = {
  history: PropTypes.object
};

export default withRouter(SignUp);
